export enum SOType {
  B2C = 0,
  B2B = 1,
  Empact = 2,
  ReportingTool
}
